/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

interface AttendanceSummaryMetric {
  count: number;
  percentageChange: number;
}

interface AttendanceSummaryData {
  filterDate?: string;
  totalEmployees: number;
  present: AttendanceSummaryMetric;
  lateLogin: AttendanceSummaryMetric;
  absent: AttendanceSummaryMetric;
  totalAbsentees: number;
}

interface AttendanceSummaryResponse {
  success: boolean;
  data: AttendanceSummaryData;
}

const getAttendanceSummary = async (date?: string): Promise<AttendanceSummaryResponse> => {
  const url = date
    ? `/attendance/summary/today?date=${date}`
    : `/attendance/summary/today`;

  const { data } = await customAxios.get<AttendanceSummaryResponse>(url);
  return data;
};

export const useGetAttendanceSummary = (date?: string) =>
  useQuery<AttendanceSummaryResponse, AxiosError>(
    ["attendance-summary", date ?? "today"], // cache by date ✅
    () => getAttendanceSummary(date),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Attendance Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load attendance summary",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
